import { useEffect, useState } from "react";
import confetti from "canvas-confetti";
import api from "@/lib/api";
import { Award, Sprout, HandHeart, Crown, Heart, Star, ShieldCheck, Sunrise } from "lucide-react";

const ICONS = { sprout: Sprout, "hand-heart": HandHeart, crown: Crown, heart: Heart, hearts: Heart, star: Star, "shield-check": ShieldCheck, sunrise: Sunrise };

export default function BadgeCelebration() {
  const [badges, setBadges] = useState([]);

  useEffect(() => {
    api.get("/badges/celebrate").then((r) => {
      if (r.data.length) {
        setBadges(r.data);
        const colors = ["#D96B43", "#2E7D6B", "#D99B26", "#F3C9B1"];
        confetti({ particleCount: 140, spread: 80, origin: { y: 0.6 }, colors });
        setTimeout(() => confetti({ particleCount: 80, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, colors }), 400);
        setTimeout(() => confetti({ particleCount: 80, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors }), 400);
      }
    }).catch(() => {});
  }, []);

  const dismiss = async () => {
    setBadges([]);
    await api.post("/badges/celebrated").catch(() => {});
  };

  if (!badges.length) return null;
  return (
    <div data-testid="badge-celebration" className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-3xl p-8 max-w-md w-full text-center shadow-2xl border-4 border-[#D99B26]">
        <Award className="w-12 h-12 text-[#D99B26] mx-auto" />
        <h2 className="text-3xl font-display font-bold text-slate-900 mt-3">{badges.length === 1 ? "You earned a new badge!" : `You earned ${badges.length} new badges!`}</h2>
        <div className="mt-5 space-y-3">
          {badges.map((b) => {
            const Icon = ICONS[b.icon] || Award;
            return (
              <div key={b.key} data-testid={`celebrate-badge-${b.key}`} className="flex items-center gap-4 bg-[#FFF7E6] border-2 border-[#F1D9A3] rounded-2xl p-4 text-left">
                <span className="w-14 h-14 rounded-full bg-white flex items-center justify-center shrink-0"><Icon className="w-7 h-7 text-[#8A5A00]" /></span>
                <div><p className="text-xl font-semibold text-slate-900">{b.title}</p><p className="text-slate-700">{b.description}</p></div>
              </div>
            );
          })}
        </div>
        <p className="text-slate-600 mt-5">It now shines on your profile. We've also emailed you a little note.</p>
        <button data-testid="celebrate-dismiss-btn" onClick={dismiss}
          className="mt-5 w-full bg-[#D96B43] hover:bg-[#C25832] text-white font-bold min-h-[56px] rounded-xl text-xl transition-colors">Wonderful!</button>
      </div>
    </div>
  );
}
